module.exports = __webpack_public_path__ + "static/media/whise-academy.5542d1dc.jpg";